export default "__VITE_ASSET__CS4tonr6__"